import React, { useState } from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import { Sidebar } from './Sidebar';
import Header from './Header';
import { cn } from '../../lib/utils';
import { Toaster } from '../ui/sonner';
import NewChargerNotification from '../common/NewChargerNotification';

export const Layout = () => {
  const { isAuthenticated, loading } = useAuth();
  const { isDark } = useTheme();
  const location = useLocation();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const isLiveBoard = location.pathname === '/live';

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Full-screen live board — no sidebar/header chrome
  if (isLiveBoard) {
    return (
      <div className={cn('min-h-screen bg-background transition-colors duration-300', isDark ? 'dark' : 'light')}>
        <Outlet />
        <Toaster richColors position="top-right" />
      </div>
    );
  }

  return (
    <div className={cn('min-h-screen bg-background transition-colors duration-300', isDark ? 'dark' : 'light')}>
      <Sidebar 
        collapsed={sidebarCollapsed} 
        setCollapsed={setSidebarCollapsed}
        mobileOpen={mobileMenuOpen}
        setMobileOpen={setMobileMenuOpen}
      />
      
      <div className={cn(
        'main-content transition-all duration-300',
        sidebarCollapsed && 'lg:sidebar-collapsed'
      )}>
        <Header 
          onMobileMenuToggle={() => setMobileMenuOpen(!mobileMenuOpen)}
          showMobileMenu={true}
        />
        <main className="p-3 sm:p-4 md:p-6 animate-fade-in">
          <Outlet />
        </main>
      </div>
      
      <Toaster richColors position="top-right" />
      <NewChargerNotification />
    </div>
  );
};

export default Layout;
